<script>
	import { slide } from "svelte/transition";

	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();

	const locals = {
		en: "en",
		bg: "bg",
	};

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	let local = urlParams.get("l") || urlParams.get("lang") || navigator.language; //defaults to user's language if no language is set via link parameters
	export let hasPrefLangSet = true;
	export let lang = checkPreferedLang();

	//   console.log(checkPreferedLang());

	function checkPreferedLang() {
		// console.log(navigator.language);

		if (localStorage.getItem("hasPreferedLang") === null) {
			//   hasPrefLangSet = false;
			if (navigator.language == "bg") {
				hasPrefLangSet = true;
				return "bg";
			} else {
				return locals[local] || "bg"; //defaults to ~english~ BULGARIAN if the user's language or the link param. language is not in the list
			}
		} else {
			if (localStorage.getItem("preferedLanguage") !== null) {
				hasPrefLangSet = true;
				return localStorage.getItem("preferedLanguage");
			}
		}
	}

	function setLang(l) {
		localStorage.setItem("hasPreferedLang", true);
		localStorage.setItem("preferedLanguage", l);
		lang = l;
		hasPrefLangSet = true;
		dispatch("setLang", {
			lang: lang,
			prefset: hasPrefLangSet,
		});
	}
</script>

{#if !hasPrefLangSet}
	<div
		class="fixed z-10 grid w-full h-full text-white bg-blue-200 bg-opacity-80"
		transition:slide
	>
		<div class="p-4 bg-blue-100 shadow-xl place-self-center">
			<h1 class="mb-4 sm:text-lg-subheading text-lg-subheading">
				{lang === "bg"
					? "Задай своя предпочитан език"
					: "Set your preffered language"}
			</h1>

			<button
				class="p-3 transition-all duration-200 transform teal-button"
				on:click={() => setLang("bg")}>Български (Bulgarian)</button
			>
			<button
				class="p-3 transition-all duration-200 transform teal-button"
				on:click={() => setLang("en")}>English (Английски)</button
			>

			<h2 class="mt-4">
				{lang === "bg"
					? "Можеш да промениш това после от футъра на сайта"
					: "You can change this later in the site's footer"}
			</h2>
		</div>
	</div>
{/if}
